import { Component, Inject, TemplateRef, Type } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dynamic-modal',
    templateUrl: './dynamic-modal.component.html',
    styleUrls: ['./dynamic-modal.component.scss']
})
export class DynamicModalComponent {
    constructor(
        public dialogRef: MatDialogRef<DynamicModalComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title?: string;
            message?: string;
            headerBg?: boolean;
            customClass?: string;
            content: TemplateRef<unknown> | null;
            component: Type<unknown> | null;
            inputs: any;
        }
    ) {}
    
    onClose(): void {
        this.dialogRef.close(false);
    }
}
